import Mixin from "../../mixin.js";
import Utils from "../../services/utils-service.js";
import Funnel from "../../services/funnel-service.js";

import Label from "./Label.js";
import tooltip from "./tooltip.js"

const template = `
<div  v-show="fs.display(input)" >

    <div v-if="input.type != 'hidden'" aria-live="polite" aria-atomic="true" class="sr-only" :id="input.id+'_announcer'"></div>

    <div :class="radio_count" v-if="input.radio_type == '1' || !input.radio_type">
        <div role="fieldset" class="grid" :ref="'fieldset_'+input.uid">
            <legend class="s12 clm" v-if="input.force_label" >
                <component id="'legend_'+input.uid" :is="input.title_tag ? input.title_tag :'h4'" v-if="input.force_label" class="text-center s12 clm " >{{computedLabel(input)}} </component>
            </legend>
            <div class="s12 clm" role="radiogroup" :aria-labelledby="'fieldset_'+input.uid">
                <div class="grid">
                    <div class="s clm radio_type_1 checkbox-card" v-for="(item, index) in items" :uid="input.uid" v-show="fs.display(item)">
                        <b-tooltip :element='item' v-if="item.helpText"/>
                        <input 
                            type="radio"
                            role="radio"
                            :uid="input.uid+ '_option_' + index"
                            :id="input.id + '_option_' + index"
                            :required="input.validation.required"
                            :name="input.element_name"
                            :checked="setChecked(item)"
                            @change="exec($event, input)"
                            :value="item.value"
                            :disabled="setDisabled(item.disabled)"
                            v-bind="validationRules"
                            :data-uid="input.uid"
                            :aria-checked="setChecked(item)"
                        />
                        <qt-label :iuid="iuid" :format="'custom'" :img="fs.icon(item)" :item='item' :item_index='index'></qt-label>
                    </div>
                </div>
            </div>
        </div>
        <div class="error-here" :id="input.uid+'_error'"></div>
        <input
            :uid="input.uid+ '_hidden_'"
            type="hidden"
            :id="input.id"
            :required="input.validation.required"
            :name="input.element_name"
            :value="input.value"
            :data-uid="input.uid+ '_hidden_'"
        />
    </div>
    <div role="fieldset"  v-if="input.radio_type == '2' || input.radio_type == 'pill'" class="grid collapse bool-radio radio_type_2" :ref="'fieldset_'+input.uid">
        <legend>
            <component :is="input.title_tag ? input.title_tag :'h4'" v-if="input.force_label" class="text-center s12 clm " >{{computedLabel(input)}} </component>
        </legend>
        <div class="s12 clm">
            <div class="grid" role="radiogroup" :aria-labelledby="'fieldset_'+input.uid">
                <div class="s6 clm pill-container pill-wrapper" :class="boolRadioClass" v-for="(item, index) in input.options" :uid="input.uid" v-show="fs.display(item)">
                    <input 
                        type="radio"
                        role="radio"
                        :uid="input.uid+ '_option_' + index"
                        :id="input.id+ '_option_' + index"
                        :required="input.validation.required"
                        :name="input.element_name"
                        :checked="setChecked(item)"
                        @change="exec($event, input)"
                        :disabled="setDisabled(item.disabled)"
                        :value="item.value"
                        :data-uid="input.uid"
                        :aria-checked="setChecked(item)"
                    />
                    <qt-label :iuid="iuid" :item='item' :item_index='index' :format="'custom'"></qt-label>
                </div>
            </div>
       </div>
    </div>
    <div v-if="input.radio_type == '2' || input.radio_type == 'pill'" class="error-here" :id="input.uid+'_error'"></div>
    
    <div role="fieldset"  v-if="input.radio_type == '3' || input.radio_type == 'card-toggle'" class="grid collapse bool-radio card radio_type_3" :ref="'fieldset_'+input.uid">
        <legend class="s12 clm center card-toggle-question text-center">
            <b-tooltip :element='input' v-if="input.helpText"/>
            <img :src="fs.icon(input)" alt="" class="icon iconic center" />
            <component :is="input.title_tag ? input.title_tag :'p'" :class="input.title_class" >
                {{computedLabel(input)}}
            </component>
        </legend>
        <div class="s12 clm">
            <div class="grid pill-wrapper" role="radiogroup" :aria-labelledby="'fieldset_'+input.uid">
                <div class="s6 clm pill-container " :class="boolRadioClass(item)" v-for="(item, index) in input.options" :uid="input.uid" v-show="fs.display(item)">
                    <input 
                        type="radio"
                        role="radio"
                        :uid="input.uid+ '_option_' + index"
                        :id="input.id+ '_option_' + index"
                        :required="input.validation.required"
                        :name="input.element_name"
                        :checked="setChecked(item)"
                        @change="exec($event, input)"
                        :disabled="setDisabled(item.disabled)"
                        :value="item.value"
                        :data-uid="input.uid"
                        :aria-checked="setChecked(item)"
                        
                    />
                    <qt-label :iuid="iuid" :item='item' :item_index='index' :format="'custom'" ></qt-label>
                </div>
            </div>
        </div>
            
    </div>
    <div v-if="input.radio_type == '3' || input.radio_type == 'card-toggle'" class="error-here" :id="input.uid+'_error'" role="alert" aria-live="assertive" style="margin-top:10px;"></div>

    <div role="fieldset" :class="radio_count +' radio_4'" v-if="input.radio_type == 4"  :ref="'fieldset_'+input.uid">

        <ul role="radiogroup" class="block-grid-s1 block-grid-m2 radio_type_4" :class="gridClass" :aria-labelledby="'fieldset_'+input.uid">
            <li class="s clm" v-for="(item, index) in items" :uid="input.uid"  v-show="fs.display(item)">
                <b-tooltip :element='item' v-if="item.helpText"/>
                <input 
                    type="radio"
                    role="radio"
                    :uid="input.uid+ '_option_' + index"
                    :id="input.id + '_option_' + index"
                    :required="input.validation.required"
                    :name="input.element_name"
                    :checked="setChecked(item)"
                    @change="exec($event, input)"
                    :value="item.value"
                    :disabled="setDisabled(item.disabled)"
                    v-bind="validationRules"
                    :data-uid="input.uid"
                    :aria-checked="setChecked(item)"
                    :aria-labelledby="'label_'+input.uid+'_option_' + index"
                />
                <qt-label :iuid="iuid" :format="'custom'" :img="fs.icon(item)" :item='item' :item_index='index'></qt-label>
            </li>
        </ul>
       <div class="error-here" :id="input.uid+'_error'" role="alert" aria-live="assertive"></div>
        <input
            :uid="input.uid+ '_hidden_'"
            type="hidden"
            :id="input.id"
            :required="input.validation.required"
            :name="input.element_name"
            :value="input.value"
            :data-uid="input.uid+ '_hidden_'"
        />
    </div>
    
</div>
`;


export default {
    name: 'qt-input-radio',
    template,
    props: ['iuid'],
    mixins: [Mixin],
    components: {
        'qt-label': Label,
        'b-tooltip': tooltip
    },
    watch: {
        "input.loading": function (newVal, oldVal) {
           this.fs.elementAnnouncer(this.input)
        }
    },
    mounted: function () {
        this.handleIIFE();
        this.computedAriaLabel()
    },
    computed: {
        ...Vuex.mapGetters([
            'funnel',
            'active_page',
            'disable_next'
        ]),
        gridClass: function(){
            var self = this
            var total_items = this.input.options.filter(function(item){
                return self.fs.display(item)
            })

            
            if (this.input.grid_class) {
                var grid_size = this.input.grid_class
                var grid = "block-grid-s1 block-grid-m"+ grid_size
            }else{
                var grid_size = total_items.length
                var grid = "block-grid-s1 block-grid-m"+ (grid_size - 1) + " block-grid-l"+ grid_size
            }
            return grid;
        },
        validationRules() {
            // v-bind="validationRules"
            return this.input.validation
        },
        input: function () {
            return this.$store.getters.funnel.elements[this.iuid];
        },
        items: function () {
            return { ... this.input.options };
        },
        radio_count: function () {
            var count = 0;
            var options = this.input.options
            if (options) {
                options.forEach(function (option) {
                    count++;
                });
            }
            if (count === 2) {
                var offset = 'clm m6 center'
            } else if (count === 3) {
                var offset = 'clm m6 center'
            } else if (count === 4) {
                var offset = 'clm m8 center'
            } else if (count === 5) {
                var offset = 'clm m10 center'
            }
             
            if (this.input.radio_count_class ) {
                offset = this.input.radio_count_class
            }

            return offset;
        },
        fs: function () {
            return new Funnel({ ctx: this.$store, router: this.$router });
        }
        
    },
    methods: {
        boolRadioClass: function(item){
            var classes =[]
            if (item.label.length > 5) {
                classes.push('sm-text-12')
            }
            if (item.label.length > 10) {
                classes.push('md-text-12 ')
            }
            return classes
        },
        setChecked(item) {
            var checked = false;
            if (!Utils.isEmpty(this.input.value)) {
                checked = this.input.value.indexOf(item.value) > -1;
            }
            return checked;
        },
        computedAriaLabel: function(){
            var self = this;
            this.$nextTick(function(){
                let fieldset = self.$refs["fieldset_"+self.input.uid];
                let parent_section_dom = fieldset.closest('section')
                parent_section_dom.setAttribute('data-parent-section', "ps_"+self.input.uid)

                let parent_section_id = $('section[data-parent-section='+"ps_"+self.input.uid+']').attr('id')

                let parent_section_element = self.funnel.elements[parent_section_id];


                if ((parent_section_element.description && parent_section_element.title) || (parent_section_element.description && !parent_section_element.title)) {
                    fieldset.setAttribute('aria-label', parent_section_element.description);
                }
                if (!parent_section_element.description && parent_section_element.title) {
                    fieldset.setAttribute('aria-label', parent_section_element.title);
                }
                else if (self.input.title_tag) {
                    fieldset.setAttribute('aria-label', self.input.label);
                }
            })
        }
        
    }
};
